"use client";

import dynamic from "next/dynamic";
import { Skeleton } from "@/components/ui/skeleton";
import type { PropertyStatus, PropertyType } from "@/types/database";

const MapView = dynamic(() => import("./map-view"), {
  ssr: false,
  loading: () => (
    <div className="w-full h-full bg-secondary/5 flex items-center justify-center">
      <Skeleton className="w-full h-full" />
    </div>
  ),
});

// Legacy property format (from mock data)
interface LegacyProperty {
  id: string;
  name: string;
  location?: string;
  community?: string;
  price: string;
  image: string;
  status?: string;
  type?: string;
}

// Database property format
interface DatabaseProperty {
  id: number;
  name: string;
  location_name: string;
  price_from: number;
  currency?: string;
  hero_image_url: string;
  status: PropertyStatus;
  type: PropertyType;
  latitude?: number | null;
  longitude?: number | null;
}

export type PropertyMapInput = LegacyProperty | DatabaseProperty;

interface PropertyMapProps {
  properties: PropertyMapInput[];
  onClose: () => void;
  className?: string;
  activePropertyId?: string | null;
  onMarkerHover?: (id: string) => void;
  onMarkerLeave?: () => void;
}

export function PropertyMap(props: PropertyMapProps) {
  return <MapView {...props} />;
}
